export const bookingInitialValue = {
    id: { value: "", show: true },
    itinerary_id: { value: "", show: true },
    year: { value: { id: "", name: "" }, show: true, },
    week: { value: "", show: true },
    id_client: { value: "", show: true },
    port_load_id: { value: { id: "", name: "" }, show: true },
    port_origin_id: { value: { id: "", name: "" }, show: true },
    port_discharge_id: { value: { id: "", name: "" }, show: true },
    port_destination_id: { value: { id: "", name: "" }, show: true },
    vessel: { value: "", show: true },
    voyage: { value: "", show: true },
    haulage_carrier_id: { value: false, show: true },
    haulage_rampla_type: { value: "", show: true },
    haulage_cost: { value: "", show: true },
    haulage_transport_type: { value: "", show: true },
    //Servicio Integral
    has_si: { value: "", show: true },
    si_type_id: { value: "", show: true },
    //Shipper
    shipper: { value: { id: "", name: "" }, show: true },
    shipper_address_id: { value: { id: "", name: "" }, show: true },
    shipper_consignee_id: { value: { id: "", name: "" }, show: true },
    shipper_notify_id: { value: { id: "", name: "" }, show: true },
    //Información relevante a la carga
    container_id: { value: { id: "", name: "" }, show: true },
    id_client_product: { value: { id: "", name: "" }, show: true },
    embarked_containers: { value: "", show: false },
    containers_requested: { value: "", show: true },
    cantidad_bi: { value: { name: "" }, show: false },
    //IsReefer
    container_temperature: { value: "", show: true },
    container_percent_ventilation: { value: "", show: true },
    ventilacion_cbm: { value: "", show: true },
    container_cold_treatment: { value: "", show: true },
    //isAtmosphera
    container_atmosphere_id: { value: { id: "", name: "" }, show: true },
    container_percent_o2: { value: "", show: true },
    container_percent_co2: { value: "", show: true },
    //Información adicional
    payment_method: { value: { id: "", name: "" }, show: true },
    genset: { value: "", show: true },
    emition_bl: { value: "", show: true },
    comment: { value: "", show: true },
    contract: { value: "", show: true },
    contract_number: { value: "", show: true },
    itineraries: { naviera_id: "" },
    with_frozen: { value: "" },
    with_ac: { value: "" },
    //nuevos campo terrestre
    haulage_port_origin_id: { value: { id: "", name: ""}, show: true },
    haulage_withdrawal_date: { value: "", show: true },
    haulage_rampla: { value: "", show: true },
    haulage_packing_id: { value: { id: "", name: "" }, show: true },
    haulage_carrier: { value: "", show: true },
    haulage_movement_type: { value: "", show: true },
    pol_etd: { value: "", show: true },
    shipper_id: { value: { id: "", name: "" }, show: true },
};